import * as types from 'constants/ActionTypes';
import { APPOINTMENT } from 'constants/ExtensionConstants';
import { FETCH_APPOINTMENT_SUCCESS } from 'modules/appointments/actionTypes';
import { GET_MODAL_DEALERS_SUCCESS, GET_PAGINATED_DEALERS_FETCH_SUCCESS } from 'modules/dealers/actionTypes';
import { uniq } from 'utils/ObjectUtils';
import { createReducer } from 'utils/ReduxUtils';

import { changeDealerStatusSuccessReducer } from '../../utils/DealersReducersUtils';
import { mergeByExtensions } from '../extensions/utils';

// Contains all dealer ids that have been fetched so far for the KEY DEPOSIT feature
const initialState = [];

const initialStateReducer = () => initialState;

const fetchDealersSuccessReducer = (state, { payload }) => mergeByExtensions(state, payload.content, APPOINTMENT);

const fetchDealerSuccessReducer = (state, { payload: dealer }) =>
  fetchDealersSuccessReducer(state, { payload: { content: [dealer] } });

const afterFetchOtherEntity = (state, { payload }) => uniq([...state, payload.dealerId ?? payload.dealer.id]);

export default createReducer(initialState, {
  [FETCH_APPOINTMENT_SUCCESS]: afterFetchOtherEntity,
  [GET_MODAL_DEALERS_SUCCESS]: fetchDealersSuccessReducer,
  [GET_PAGINATED_DEALERS_FETCH_SUCCESS]: fetchDealersSuccessReducer,
  [types.FETCH_DEALER_SUCCESS]: fetchDealerSuccessReducer,
  [types.FETCH_DEALERS_SELECT_FAILURE]: initialStateReducer,
  [types.FETCH_DEALERS_SELECT_SUCCESS]: fetchDealersSuccessReducer,
  [types.CHANGE_DEALER_STATUS_SUCCESS]: changeDealerStatusSuccessReducer,
});
